// Polyfill for IE 11 https://vuetifyjs.com/en/directives/intersect/#polyfill
import 'intersection-observer'
import cssVars from 'css-vars-ponyfill'
import 'string.prototype.startswith'
import 'font-awesome/css/font-awesome.min.css'
import 'animate.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import { MoneyPlugin } from './components/shared/formatters/money'
import { ValidatorPlugin } from './components/shared/forms/validator-plugin'
import i18n from './i18n'
import rollbar from 'vue-rollbar'
import {
  accessToken,
  rollbarOptions
} from './components/shared/rollbar/rollbar-configuration'
import { isNotADevelopmentEnvironment } from './components/shared/environment/environment-helper'
import { SplitPlugin } from '@/plugins/split/SplitPlugin'
import VueAnnouncer from 'vue-announcer'
import store from './store'
import VueTheMask from 'vue-the-mask'
import { SegmentPlugin } from '@/plugins/segment/SegmentPlugin'
import vuetify from './plugins/vuetify'
import './scss/overrides.scss'
import { TcVBtn } from '@tangocard/mango'
import AdaChatbotPlugin from '@/components/shared/ada/AdaChatbotPlugin'
import { worker } from './mock-api/browser'

// From Vuetify Docs (https://vuetifyjs.com/en/customization/theme/#custom-properties):
// Custom properties are not natively supported in Internet Explorer.
// Polyfills (with some limitations) are available:
// https://jhildenbiddle.github.io/css-vars-ponyfill/#/
cssVars()

Vue.config.productionTip = false
Vue.use(MoneyPlugin)
Vue.use(ValidatorPlugin)
Vue.use(SplitPlugin)
Vue.use(VueAnnouncer)
if (isNotADevelopmentEnvironment()) {
  Vue.use(rollbar, { accessToken, ...rollbarOptions })
}
Vue.use(AdaChatbotPlugin)
Vue.use(VueTheMask)
Vue.use(SegmentPlugin)
Vue.component('TcVBtn', TcVBtn)

worker.start()

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
